const API_BASE_URL = process.env.REACT_APP_API_BASE_URL 

const token = localStorage.getItem('authToken') || null; 

// Fonction utilitaire pour gérer les réponses API
async function handleResponse(response) {
  const status = response.status;

  let responseData;
  try {
    responseData = await response.json();
  } catch {
    responseData = { message: response.statusText };
  }

  if (!response.ok) {
    // On retourne une erreur avec le code + message
    const error = new Error(responseData.message || responseData.error || 'Something went wrong with the API call.');
    error.status = status;
    throw error;
  }

  return responseData;
}

// Fonction générique pour les requêtes GET
export async function get(endpoint, params = {}) {
  const headers = {
    'Content-Type': 'application/json',
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  if (params) {
    const searchParams = new URLSearchParams(params);
    endpoint += `?${searchParams.toString()}`;
  }
  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    method: 'GET',
    headers: headers,
  });
  return handleResponse(response);
}

// Fonction générique pour les requêtes POST
export async function post(endpoint, data) {
  const headers = {
    'Content-Type': 'application/json',
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data),
  });
  return handleResponse(response);
}

// Ajoutez d'autres fonctions pour PUT, DELETE, etc. selon vos besoins
export async function put(endpoint, data) {
  const headers = {
    'Content-Type': 'application/json',
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify(data),
  });
  return handleResponse(response);
}

// Ajoute une fonction PATCH si nécessaire
export async function patch(endpoint, data) {
  const headers = {
    'Content-Type': 'application/json',
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    method: 'PATCH',
    headers: headers,
    body: JSON.stringify(data),
  });
  return handleResponse(response);
}


// Fonction générique pour les requêtes DELETE
export async function del(endpoint) {
  const headers = {
    'Content-Type': 'application/json',
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    method: 'DELETE',
    headers: headers,
  });
  return handleResponse(response);
}
